export default __webpack_public_path__ + "static/media/gallery_07.a68fa24c.jpg";